import PageSEO from '@/components/feature/PageSEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import NewsletterSection from './components/NewsletterSection';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9rd8nvnahb7382ovksg';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '今日同人库',
  url: 'https://todaydoujin.com/',
  description: '今日同人库是专为同人爱好者打造的每日内容聚合平台，汇聚最新同人小说、同人画作、同人音乐与周边资讯。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://todaydoujin.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="今日同人库 - 每日精选同人内容聚合平台"
        description="今日同人库是专为同人爱好者打造的每日内容聚合平台，汇聚最新同人小说、同人画作、同人音乐与周边资讯。每日更新精选推荐，发现你最爱的CP与原创同人作品。"
        keywords="今日同人库,同人内容聚合,每日同人推荐,同人小说平台,同人画作欣赏,CP同人作品,同人周边资讯"
        canonicalUrl="/"
        jsonLd={homepageJsonLd}
      />
      <HeroSection />
      <CategoryGrid />
      <FeaturedSection />
      <LatestSection />
      <NewsletterSection formUrl={NEWSLETTER_FORM_URL} />
    </>
  );
}